<template>
  <div>
    <h1 class="mb-5 title">
      <b-icon-arrow-left
        class="clickable"
        @click="$emit('back')"
      />
      {{ id }} Users
    </h1>

    <b-form-input
      v-model="filter"
      class="mb-3"
      placeholder="Filter users"
    />

    <TableList
      :data="filteredUsers"
      :fields="fields"
      :loading="loading"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { BIconArrowLeft } from 'bootstrap-vue'
import TableList from './common/ResourceList.vue'

export default {
  name: 'ResourceUsers',
  components: {
    BIconArrowLeft,
    TableList
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      filter: '',
      fields: [
        {
          key: 'username',
          label: 'Username',
          sortable: true
        },
        {
          key: 'name',
          label: 'Name',
          sortable: true
        },
        {
          key: 'active',
          label: 'Is Active',
          sortable: true
        },
        {
          key: 'hostIp',
          label: 'Host IP',
          sortable: true
        }
      ]
    }
  },
  async created() {
    this.$store.commit('otherResources/setResourceID', {
      id: this.id
    })

    await this.$store.dispatch(
      'otherResources/retrieveResourceUserList'
    )
  },
  computed: {
    ...mapState({
      users: state => state.otherResources.user_list,
      loading: state => state.otherResources.loading
    }),

    userRows() {
      return this.users.map(user => ({
        username: user.username,
        name: user.name,
        active:
          Number(user.active) === 1 ? 'Yes'
          : Number(user.active) === 0 ? 'No'
          : 'Unknown',
        hostIp: user.host?.ip ?? ''
      }))
    },

    filteredUsers() {
      const filter = this.filter.toLowerCase().trim()

      if (!filter) {
        return this.userRows
      }

      return this.userRows.filter(user =>
        Object.values(user).some(value =>
          String(value ?? '')
            .toLowerCase()
            .includes(filter)
        )
      )
    }
  }
}
</script>

<style scoped>
.title {
  text-align: left;
}

.clickable {
  cursor: pointer;
  margin-right: 0.5rem;
}
</style>